<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'1000px','max-height':'800px'}">

        <div class="flex" >

            <Tree :data="data1" ref="tree" @on-select-change='selectType' :empty-text="$t('selectloadingPlaceholder')"></Tree>
            <div style="flex-grow:1">
                 <Input suffix="ios-search" v-model='searchBN' search  :placeholder="$t('BasicProduct.titleName.basicName')" style="width: auto;margin:0 0 20px 20px" @on-search="searchData" />
                 <div v-if="loading"> <Button loading shape="circle"></Button></div>
                <div v-else class="goodsCon flex ">
                   <div class="goodsItemCon" v-for="(item,index) in tableData" :key="index"  @click="subData(item)">
                        <div class="goodsItem">
                            <div class="topInfo">
                                <div class="imgCon flexCC" >
                                    <img :src="config.sourceUrl+'?fid='+item.imageId" alt="" srcset="">
                                </div>
                                <div class="goodName one-txt-cut">{{item.basicName}}</div>
                            </div>
                            <div class="bottomInfo flexCC">
                                <div class="timerCon flexBC flexD">
                                    <div class="dataNum one-txt-cut">{{item.remark}}</div>
                                </div>
                                <!-- <div class="timerCon flexBC flexD">
                                    <div class="dataNum numCon">{{item.activateNumber}}</div>
                                </div> -->
                            </div>
                       </div>
                       <!-- <Button class="selectButton"  @click="subData(item)">{{$t('cancel')}}</Button> -->
                   </div>
                   <div class="" v-if='tableData.length==0' style="margin:0 auto">
                      {{$t("nodata")}}
                   </div>
                </div>
            </div>
        </div>
        

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import {toTree} from "@/libs/tools.js"
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            tempId:Number|String
        },
        name: "temModel",
        components: {
        },
        data() {
            return {   
                title: '',//弹框标题
                data1: [],
                tableData:[],
                tableDataALL:[],
                searchBN:'',//搜索的内容
                treeId:'',
                loading:false
            }
        },
        watch:{
            showModel(val){
                if(val){
                    this.getCate()
                }
            },
        },
        methods: {
            getCate(){//获取分类数据,第一层分类
             
                this.axios.post(this.config.urlArray.typeCateList, {parentClassId:null}).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data
                   this.data1  =  toTree(resData,'className','id','title','id') 
                })
            },
            getData(){//获取模板数据
                this.loading  = true
                let params = {basicClassId:this.treeId||'',published:true}
                this.axios.post(this.config.urlArray.typeList, params).then((result) => {
                    // common.ajaxMsg(result.data);
                    let resData = result.data.data
                    //  console.log('resData',resData)
                    //处理数组
                    this.tableData  =  resData
                    this.tableDataALL  =  resData

                    this.loading  = false
                }).catch((err) => {
                    this.loading  = false
                    console.log(err)
                });

            },
            searchData(val){//没有分页，做假搜索,模糊匹配
               this.getData1(val)
            },
            getData1(val){
                // console.log('val',val)
                if(val!==''){
                    var reg = new RegExp(val);
                    this.tableData = this.tableDataALL.filter((item)=>{
                        return item.basicName.match(reg)
                    })
                    return
                }

                if(val===''){
                  this.getData()
                }
            },
            selectType(val){//树形控件选中
            //    console.log(val)
               this.searchBN = ''
               this.treeId = val[0].id
               this.getData()
            },
            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('productManage.manageModel.stitle')
                    this.getData()
                } else { //关闭弹框后要做的处理
                    this.cancel()
                }
            },
            subData(item) {//选择模板
               this.$emit('update:tempIdObj',item);
               this.$emit('update:showModel',false);
            },
            cancel() {//对话框关闭
                this.searchBN = ''
                this.treeId = ''
                this.fn()
                this.$emit('update:showModel',false);
            }
        }
    }
</script>
<style lang="less" scoped>
.simple-size {
    color: #ccc;
    font-size: 12px;
    height: 20px;
    padding: 0;
    margin: 0;
}
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
}
.goodsCon{
     flex-wrap: wrap;
      // overflow-y: scroll;
        overflow: auto;
     max-height: 500px;
     min-height: 300px;
     flex-grow: 1;
     .goodsItemCon{
         width:46%;
         margin-left: 2%;
         margin-bottom: 20px;
     }
     .goodsItem{
        
         background-color: #fff;
         border: 2px solid #E5E5E5;
         border-radius: 10px;
         padding: 20px 30px;
        
         min-width: 193px;
         overflow-x: hidden;
         cursor: pointer;
         .imgCon{
             width: 120px;
             height: 120px;
             margin: 0 auto;
             img{
                 width: auto;
                 height: 100%;
                 max-width: calc(100% + 90px);
             }
         }
         .goodName{
             color: #3A464E;
             margin-top: 7px;
             text-align: center;
         }
         .bottomInfo{
             margin-top: 20px;
             color: #3A464E;
             text-align: center;
             line-height: normal;
             .desc{
                 font-size: 12px;
                 color: #A4B4BF;
                 margin-top: 15px;
             }
             .dataNum{
                 height: 26px;
                 line-height: 26px;
             }
             .numCon{
                font-size: 20px;
                font-family: Source Han Sans SC;
                font-weight: bold;
                color: #E76D6A;
             }
         }
     }
     .selectButton{
         margin-top: 10px;
         position: relative;
         left: 50%;
         transform: translateX(-50%);
     }
 }
 .ivu-tree{
     min-width: 200px;
     flex-shrink: 0;
     border-right: 1px solid #e8eaec;
 }
</style>